export default "__VITE_ASSET__Cu3CcRmN__"